import { useQuery } from "@tanstack/react-query";
import BinApiService from "src/api/BinApiService";
import { deviceQueryKeys } from "src/components/BinDetails";

export const useBinStateFromDevice = (params: {
    azureDeviceID: string | null | undefined, binId: number, userTimeZoneOffset: number
},
    queryOptions: {
        enabled?: boolean,
        staleTime?: number,
        refetchInterval?: number,
    }
) => {

    return useQuery(deviceQueryKeys.stateFromDevice(params.azureDeviceID!), async (q) => {
        if (params.azureDeviceID == null) {
            throw new Error("No Azure device supplied");
        }
        const binDTO = await BinApiService.getBinDetailFromDevice(params.azureDeviceID!, params.binId, params.userTimeZoneOffset, q.signal);
        if (binDTO == null) {
            throw new Error("Bin State from device is empty");
        }
        return binDTO;
    }, {
        enabled: queryOptions.enabled,
        refetchInterval: queryOptions.refetchInterval,
        staleTime: queryOptions.staleTime,
        onError: (err) => console.error("problem getting binState from device", err),
    });
};